import BaseBusinessAPI from '../portal/baseBusinessAPI'

class ParentCareerAPI extends BaseBusinessAPI {
  controllerName = 'ParentCareers';
}

export default new ParentCareerAPI()
